import React from 'react'
import RecentSearch from '../WebChat/RecentChatSection/RecentSearch';
import { NO_SEARCH_CHAT_CONTACT_FOUND } from '../../processENV';
import { getMaxUsersInCall } from '../../Helpers/Call/Call';
import { Close2Hoc, FloatingCallAudioHoc, FloatingCallVideoHoc, IconCopyHoc, IconLinkHoc, InfoHoc, loaderSVG } from '../../assets/images';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getDataFromRoster, getFriendsFromRosters, getLocalUserDetails, getUserDetails, getUserInfoForSearch } from '../../Helpers/Chat/User';
import { blockOfflineMsgAction, getCallFullLink, getValidSearchVal, handleFilterBlockedContact } from '../../Helpers/Utility';
import { getFromLocalStorageAndDecrypt } from '../../Helpers/Chat/webChatEncryptDecrypt';
import { getUsersListFromSDK } from '../WebChat/RecentChatSection/userLists';
import ParticipantsBadge from './ParticipantsBadge';
import Contact from '../ContactInfo/Contact';
import { store } from '../../Redux/store';
import { addCallIntermediate } from '../../Redux/feature/callIntermediateScreenSlice';
import SDK from '../../SDK';

let rosterDatas = [];
const ParticipantPopUp = (props={}) =>{
    const storeData = useSelector((state) => state);
    const { 
        rosterData,
        appOnlineStatus : {isAppOnline}, blockedContact, recentChatItems
    } = storeData
    
    const { popUpData: { modalProps: { groupMembers, modelType ,groupMemberDetails , selectDefault, groupName, currentCallUsers,currentCallUsersLength , callType, closePopup } } } = storeData;
    const { data: rosters  } = rosterData

    let isInviteModelType = modelType === 'inviteParticipants' 
    let isCallLogModelType = modelType === 'calllogparticipants';
    let timer = 0;
    const [callLink,setCallLink]= React.useState("");
    const [getParticipantPopUp,setParticipantPopUp]= React.useState({
        group_Members: [],
        participantToAdd: isCallLogModelType ? groupMembers : [],
        errorMesage: '',
        isLoading: true,
        filteredContacts: [],
        copyToast:false,
        // callLink: "",
        loaderStatus: groupName ? false : !!rosterData?.isFetchingUserList,
        userList: [],
        callLinkinitiate: false
    }) 
    const [searchValue,setSearchValue] = React.useState('')
    const {
        group_Members,
        participantToAdd,
        errorMesage,
        // isLoading,
        filteredContacts,
        copyToast,
        // callLink,
        loaderStatus,
        userList,
        callLinkinitiate
    } = getParticipantPopUp

    const invideModeFun = () => {
        return isInviteModelType ? 'Invite Participants' : "Group Call"
    };
    const errorMessageListner = (errorMessage) => {
        setParticipantPopUp({
            ...getParticipantPopUp,
            errorMesage: errorMessage
        })
    }

    const contactsSearch = (searchTerm) => {
        if (group_Members) {
            return group_Members.filter((item) => {
                const rosterJid = item.username || item.userJid;
                if (searchTerm === "") {
                    if (participantToAdd.indexOf(rosterJid) === -1) {
                        return false
                    }
                }
                const regexList = getUserInfoForSearch(item);
                return regexList.find((str) => {
                    return (str.search(new RegExp(searchTerm, "i")) !== -1)
                });
            });
        }
        return "";
    }

    const searchFilterList = (searchValueList) => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            searchValueList = getValidSearchVal(searchValueList);
            let searchWith = searchValueList;
            if (!searchValueList) {
                let data = rosterDatas;
                setSearchValue('')
                setParticipantPopUp({
                    ...getParticipantPopUp,
                    errorMesage: '',
                    filteredContacts: data,
                    userList: data
                })
                if (isInviteModelType && !groupName && !isCallLogModelType) {
                    getUsersListFromSDK(1, searchWith);
                }     
                return;
            }
            const searchFilteredContacts = contactsSearch(searchWith).filter(item=>item?.isAdminBlocked !== true && item?.isDeletedUser !== true)
            setSearchValue(searchValueList);
            setParticipantPopUp({
                ...getParticipantPopUp,
                filteredContacts: searchFilteredContacts,
                userList: searchFilteredContacts
            })
            if (isInviteModelType && !groupName && !isCallLogModelType) {
                    getUsersListFromSDK(1, searchWith);
            }
        }, 0);
    }

    const removeParticipant = (userName) => {
        let participants = participantToAdd;
        participants = participants.filter(item => item !== userName)
        setParticipantPopUp({
            ...getParticipantPopUp,
            participantToAdd: participants });
    }

    const addParticipant = (userName, userInfo) => {
        let participants = participantToAdd;
        participants.push(userName);
        setParticipantPopUp({
            ...getParticipantPopUp,
            participantToAdd: participants });
    }

    const prepareContactToAdd = (userName, userInfo) => {
        const exists = participantToAdd.includes(userName);
        if (!exists) {
            return addParticipant(userName, userInfo);
        }
        return true;
    }

    const prepareContactToRemove = (userName, userInfo) => {
        const exists = participantToAdd.includes(userName);
        if (exists) {
            return removeParticipant(userName);
        }
        return "";
    }

    const renderParticpantPopup = () => {
        let data = [];
        const vcardData = getLocalUserDetails();

        if (isInviteModelType && !groupName && !isCallLogModelType) {
            let usersList = getFriendsFromRosters(handleFilterBlockedContact(rosters))
            usersList.map(member => {
                let rosterDataUser = {};
                let user = member.userJid || member.GroupUser || member.username;
                const userId = user.includes("@") ? user.split('@')[0] : user;
                if (userId !== vcardData.fromUser) {
                    rosterDataUser = getUserDetails(userId);
                    data.push(rosterDataUser)
                }
            });
        } else {
            groupMemberDetails.map(member => {
                let rosterDataGroup = {};
                let user = member.userJid || member.GroupUser || member.username;
                const userId = user.includes("@") ? user.split('@')[0] : user;
                if (userId !== vcardData.fromUser) {
                    rosterDataGroup = getUserDetails(userId);
                    data.push(rosterDataGroup)
                }
            });
        }

        rosterDatas = data;

        let filteredContactsList = data.filter((item) => {
            if(isCallLogModelType && groupName) {
                let rosterJid = (item.username) ? item.username : item.userJid;
                if (groupMembers.indexOf(rosterJid) === -1) {
                    return false
                }
            }
            if(isInviteModelType) {
                let rosterJid = (item.username) ? item.username : item.userJid;
                rosterJid = rosterJid.split('@')[0];
                if (currentCallUsers.indexOf(rosterJid) > -1) {
                    return false
                }                
            }
            const { emailId = null, name = null, displayName = null, nickName = null } = item;
            const regexList = Object.values({ emailId, name, displayName, nickName })
            return regexList.find((str) => {
                if (str) {
                    return (str.search(new RegExp(searchValue ? searchValue : "", "i")) !== -1)
                }
                return false;
            });
        });
        const adminFilteredContact = filteredContactsList.filter(item=>item?.isAdminBlocked !== true && item?.isDeletedUser !== true)
        if(selectDefault && adminFilteredContact.length <= 7){
            adminFilteredContact.forEach((user) => {
                prepareContactToAdd(user.userJid);
            });
        }
        setParticipantPopUp({
            ...getParticipantPopUp,
            filteredContacts: adminFilteredContact, userList: adminFilteredContact, group_Members: rosterDatas 
        });
    }

    const addUsersInCall = () => {
        if(blockOfflineMsgAction()) return
        const { popUpData: { modalProps: { makeGroupCall, groupuniqueId } } } = storeData
        let membersCount = participantToAdd.length;
        if (membersCount < 1) {
            toast.error("Select minimum of one contacts");
            return
        }
        membersCount = membersCount + (currentCallUsersLength || 0);
        if (membersCount > (getMaxUsersInCall() - 1)) {
            toast.error("Maximum " + getMaxUsersInCall() + " members allowed in a call");
            return
        }
        if (membersCount <= (getMaxUsersInCall() - 1)) {
            setParticipantPopUp({
                ...getParticipantPopUp,
                errorMesage: ''
            })
            makeGroupCall(callType, participantToAdd, groupuniqueId);
            closePopup();
        }
    }

    const fetchMoreData = () => {
        let userListArrList = userList;
        let searchWith = getValidSearchVal(searchValue);
        !isCallLogModelType && getUsersListFromSDK(Math.ceil((userListArrList.length / 20) + 1), searchWith);
    }

    const handleUserListData = () =>{
        let dataArr = [];
        const stateFilteredContactsList = getParticipantPopUp.filteredContacts;
        const maxMemberReached = Boolean((participantToAdd.length + (currentCallUsersLength || 0)) >= (getMaxUsersInCall() - 1));
        const hideCheckbox = isCallLogModelType;
        const blockedContactArr = blockedContact.data;
        let filteredContactsDataList = stateFilteredContactsList && stateFilteredContactsList.filter(item=>item?.isAdminBlocked !== true)
        if (userList.length > 0 && !getParticipantPopUp.loaderStatus) {
            userList.map((contact) => {
                const { displayName, name, username, userJid, status, initialName, userId } = contact
                const contactName = displayName || name || username
                let updateJid = username || userJid
                let isChanged = participantToAdd.includes(updateJid) ? 1 : -1;
                const isBlocked = blockedContactArr.indexOf(updateJid.includes("@") ? updateJid : updateJid + "@" + REACT_APP_XMPP_SOCKET_HOST) > -1;
                let isBlockedAdmins = getDataFromRoster(userId) || {};
                let isAdminBlocked = isBlockedAdmins.isAdminBlocked
                dataArr.push(
                    <Contact
                        initialName = {initialName}
                        isBlocked={isBlocked}
                        contactBlock={isAdminBlocked}
                        searchValue={searchValue}
                        contactName={contactName}
                        thumbImage={contact.thumbImage}
                        isChanged={isChanged}
                        statusMsg={status}
                        image={contact.image}
                        emailId={contact.emailId}
                        membersCount={filteredContactsDataList.length + participantToAdd.length}
                        errorMessageListner={errorMessageListner}
                        prepareContactToAdd={prepareContactToAdd}
                        prepareContactToRemove={prepareContactToRemove}
                        userJid={userJid}
                        userId={userJid}
                        key={updateJid}
                        hideCheckbox={hideCheckbox}
                        maxMemberReached={maxMemberReached}
                        roster={contact}
                    />
                )
            });
        }
        return dataArr;
    }

    const selectedBadge = () => {
        let token = getFromLocalStorageAndDecrypt('token');
        return group_Members.map((contact, key) => {
            const { displayName, name, username, userJid, image,thumbImage } = contact
            const contactName = displayName || name || username
            const updateJid = username || userJid
            if (!participantToAdd.includes(updateJid)) {
                return false
            }
            return (
                <ParticipantsBadge removeParticipant={removeParticipant} key={userJid} jid={updateJid} userToken={token} image={image} contactName={contactName} thumbImage={thumbImage} />
            )
        })
    }

    const handleCopyLink = () => {
        navigator.clipboard.writeText(getCallFullLink(callLink));
        setParticipantPopUp({ ...getParticipantPopUp,
            copyToast:true
        })
        setTimeout(() => {
            setParticipantPopUp({ ...getParticipantPopUp,
                copyToast:false
            })
        }, 3000);
    }

    const getCallInfoDetails = async () => {
        if (isInviteModelType) {
            const { callIntermediateScreen: { data: { link = "" } = {} } = {} } = storeData;
            let callLink;
            if (!link) {
                const roomLink = await SDK.getCallLink();
                if (roomLink && roomLink.statusCode === 200) {
                    callLink = roomLink.data
                }
            } else {
                callLink = link;
            }
            setCallLink(callLink);
            store.dispatch(addCallIntermediate({ link: callLink }));
        }
    }

    React.useEffect(()=>{
        getCallInfoDetails();
    },[])

    React.useEffect(()=>{        
        let searchWith = getValidSearchVal(searchValue);
        const searchFilteredContacts = contactsSearch(searchWith).filter(item=>item?.isAdminBlocked !== true && item?.isDeletedUser !== true)
        setParticipantPopUp({
            ...getParticipantPopUp,
            filteredContacts: searchFilteredContacts,
            userList: searchFilteredContacts
        })
    },[recentChatItems])

    React.useEffect(()=>{
        renderParticpantPopup();
        return ()=>(clearTimeout(timer));
    },[])

    React.useEffect(()=>{
        renderParticpantPopup();
        let selectedContactId = participantToAdd.map(ele => {
            let foundRoster = rosters.find(el => el.userId === ele.split("@")[0]);
            if (!foundRoster?.isAdminBlocked && !foundRoster?.isDeletedUser) return ele;
        });

        selectedContactId = selectedContactId.filter(function( element ) {
            return element !== undefined;
        });
        if(!groupName) {
            let roaster = currentCallUsers && rosterDatas.filter(contact => !currentCallUsers.includes(contact.userId))
            setParticipantPopUp({
                ...getParticipantPopUp,
                participantToAdd: selectedContactId,
                loaderStatus: rosterData?.isFetchingUserList,
                userList: currentCallUsers ? roaster : rosterDatas,
                filteredContacts: currentCallUsers ? roaster : rosterDatas
            });
        }
    },[rosterData, recentChatItems])

    const stateFilteredContacts = filteredContacts
    let BadgeList = selectedBadge();
    const title = isCallLogModelType ? 'Participants' : invideModeFun();
    const hideSerachBox = isCallLogModelType;
    const hideBadgeList = isCallLogModelType;
    const hideCallNow = Boolean((participantToAdd.length + (currentCallUsersLength || 0)) >= (getMaxUsersInCall()));
    const isAllUsersExists = stateFilteredContacts.length === 0 && !searchValue;
    let filteredContactsData = stateFilteredContacts.filter(item=>item?.isAdminBlocked !== true)
    const userListArr = handleUserListData();

    return(
        <React.Fragment>
            <div className="popup-wrapper">
                <div className="popup-container add-participant webcall">
                    <div className="popup-container-inner">
                        <div className="popup-container-header">
                            <i onClick={closePopup} className="closePopup"><Close2Hoc viewBox="0 0 15.4 15.468"/></i>
                            <h5>
                                <span className="calltype">{title}</span>
                                {groupName && <span className="groupName">({groupName}) </span>}
                            </h5>
                            {/* <span className="webcallConnet" onClick={ this.addUsersInCall }>Connect</span> */}
                        </div>
                        {callLinkinitiate && <div className={`meetingLinkCopy`}>
                            <h3 className='meeting_heading'>Call Link</h3>
                            <div className='meeting_body'>
                                <i className='linkIcon'><IconLinkHoc/></i>
                                    <div className='link_desc'>
                                    <strong className='link_details'>{callLink}</strong>
                                    </div>
                                <i className='linkCopyIcon' onClick={() => handleCopyLink()}>
                                <IconCopyHoc/>
                                </i>
                            </div>
                        </div>}

                        {!hideSerachBox && <RecentSearch search={searchFilterList} />}

                        <div className="popup-body" style={{overflow: "hidden"}}>                                
                            <div className="contactList" style={{ height: "100%" }}>
                                {userListArr.length > 0 &&
                                    <ul className="chat-list-ul" style={{ height: "100%" }} id="scrollableUl-addparticipantCall">
                                        {!hideBadgeList &&
                                            <li className="chat-list-li BadgeContainer">
                                                <div className="selectedBadge">
                                                    <ul>
                                                        {BadgeList}
                                                    </ul>
                                                </div>
                                            </li>}
                                            {/**
                                             * {filteredContactsData.length === 0 && searchValue &&
                                             *  <span className="searchErrorMsg"><InfoHoc viewBox="0 0 8.683 8.683"/> {NO_SEARCH_CHAT_CONTACT_FOUND}</span>
                                             * {isAllUsersExists && 
                                             *  <span className="searchErrorMsg"><InfoHoc viewBox="0 0 8.683 8.683"/> All members of your contacts are already in the call.</span>
                                             */}
                                        <li>{errorMesage && <div className="errorMesage"><InfoHoc viewBox="0 0 8.683 8.683"/><span>{errorMesage}</span></div>}</li>
                                        {isAppOnline ?
                                            <InfiniteScroll
                                            dataLength={userListArr.length}
                                            next={fetchMoreData}
                                            hasMore={true}
                                            scrollableTarget="scrollableUl-addparticipantCall"
                                            >
                                            {handleUserListData()}
                                            </InfiniteScroll>
                                        : handleUserListData()
                                        }
                                    </ul>
                                }
                                {filteredContactsData.length === 0 && searchValue && !loaderStatus &&
                                    <span className="searchErrorMsg"><InfoHoc viewBox="0 0 8.683 8.683"/> {NO_SEARCH_CHAT_CONTACT_FOUND}</span>
                                }
                                {isAllUsersExists && groupName &&
                                    <span className="searchErrorMsg"><InfoHoc viewBox="0 0 8.683 8.683"/> All members of your contacts are already in the call.</span>
                                }
                                {loaderStatus && <div className="response_loader style-2">
                                    <img src={loaderSVG} alt="loader" />
                                    </div>
                                }
                            </div>
                        </div>
                        <div className={`webcallConnet ${(isAllUsersExists || hideCallNow) ? "disabled": ""}`} onClick={participantToAdd.length >= 1 ? addUsersInCall : ()=>{toast.info("Please select any Participant");}}>
                            <span className="callBtn">
                                <i>{callType === "audio" ? <FloatingCallAudioHoc viewBox="0 0 20 20"/> : <FloatingCallVideoHoc viewBox="0 0 20.013 12.205"/> }</i>
                                <span>Call now {participantToAdd.length ? `(${participantToAdd.length})` : null}</span>
                            </span>
                        </div>
                    </div>
                    {copyToast &&
                        <div className='copy_toast'>
                            <span>Call Link Copied</span>
                        </div>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}
export default ParticipantPopUp;